/* Etiquetas multiidoma en inglés. */
export default {
  "confirmFormView.importData": "IMPORT DATA",
  "confirmFormView.qrError.message": "Error reading the QR: {error}",
  "confirmFormView.qrError.title": "Error reading the QR",
  "confirmFormView.qrFormat.message": "The QR code does not match the specified format.",
  "confirmFormView.qrFormat.title": "Format error",
};
